import { BrandInitializer } from "@/components/shared/BrandInitializer";
import { Footer } from "@/components/shared/Footer";
import { Header } from "@/components/shared/Header";
import LocationsPage from "@/components/shared/LocationPage";
import { useParams } from "react-router-dom";

export default function AllLocationsPage() {
	const { product: productParam } = useParams<{ product: string }>();
	const resolveProduct = () => {
		// from URL param
		if (productParam === "arc" || productParam === "riot") {
			return productParam;
		}

		// from domain
		const host = window.location.hostname.toLowerCase();

		if (host.includes("riot")) return "riot";
		if (host.includes("arc")) return "arc";

		// default fallback
		return "arc";
	};

	const product = resolveProduct();
	return (
		<>
			<BrandInitializer product={product || ""} />
			<div className='mx-auto flex min-h-screen flex-col bg-cover bg-center bg-no-repeat'>
				<Header />
				<LocationsPage />
				<Footer />
			</div>
		</>
	);
}
